import { Pipe, PipeTransform } from '@angular/core';
import {
  CarHireAvailabilityDetailFetcher,
  InputCarHireDepot,
  CarHireDetailRequestResponse
} from '@sabstravtech/obtservices/angular';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Pipe({
  name: 'depotName',
  pure: true,
  standalone: false
})
export class DepotNamePipe implements PipeTransform {
  constructor(private getCarHireAvailabilityDetailFetcher: CarHireAvailabilityDetailFetcher) {}

  transform(
    locationCode: string,
    extendedLocationCode: string,
    vendor: string
  ): Observable<string> {
    const code = locationCode + extendedLocationCode;

    if (vendor && code) {
      const locationDetails = {
        extendedLocationCode: code,
        vendor: vendor
      };
      return this.getCarHireAvailabilityDetailFetcher.fetchList({ locationDetails }).pipe(
        take(1),
        map((results: CarHireDetailRequestResponse) => {
          if (results) {
            return ` ${results.address.name} (${results.address.city}), ${results.address.topLine}`;
          }
        })
      );
    } else {
      return of('Converting...');
    }
  }
}
